/* @flow */
import React from 'react';
import PropTypes from 'prop-types';
import { setFormatter } from '../../../helpers';
import './style.scss';

const Input = ({
  id,
  label,
  type,
  invalid,
  error,
  format,
  setValue,
  customValidation,
  ...props
}) => {
  const fill = ({ value }) => {
    if (format) {
      setValue(setFormatter(format, value));
    } else {
      setValue(value);
    }
  };
  return (
    <div className="form-group">
      <label htmlFor={id}>{label}</label>

      <input
        id={id}
        name={id}
        type={type}
        format={format}
        className={`form-control ${invalid ? 'is-invalid' : ''}`}
        onChange={({ target }) => {
          target.classList.remove('invalid');
          fill(target);
          customValidation(target.value);
        }}
        {...props}
      />
      <div className={`error-label ${invalid ? 'visible' : ''}`}>{error}</div>
    </div>
  );
};

Input.defaultProps = {
  id: '',
  label: '',
  type: 'text',
  invalid: false,
  format: null,
  setValue: () => {},
  error: '',
  customValidation: () => {}
};

Input.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  invalid: PropTypes.bool,
  format: PropTypes.string,
  setValue: PropTypes.func,
  error: PropTypes.string,
  customValidation: PropTypes.func
};

export default Input;
